import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styles from 'wienenergiedesignsystem/components/Card/Card.module.scss';
import React from 'react';
import classNames from 'classnames';
import Image from 'wienenergiedesignsystem/components/Image/Image';

var ElevatedAction = function ElevatedAction(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.action
  }, children);
};

var FullWidthImage = function FullWidthImage(_ref2) {
  var title = _ref2.title,
      image = _ref2.image,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement(Image, {
    alt: title,
    className: classNames(styles.fullWidthImage, className),
    src: image.src
  });
};

var Card = function Card(_ref3) {
  var _classNames;

  var _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? 'default' : _ref3$theme,
      children = _ref3.children,
      className = _ref3.className,
      _ref3$as = _ref3.as,
      as = _ref3$as === void 0 ? 'div' : _ref3$as,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'elevated' : _ref3$variant,
      _ref3$hasAction = _ref3.hasAction,
      hasAction = _ref3$hasAction === void 0 ? false : _ref3$hasAction,
      other = _objectWithoutPropertiesLoose(_ref3, ["theme", "children", "className", "as", "variant", "hasAction"]);

  var Element = {
    as: as
  };
  return /*#__PURE__*/React.createElement(Element.as, Object.assign({
    className: classNames(styles[theme], styles[variant], styles.container, (_classNames = {}, _classNames[styles.displayBlock] = Element.as !== 'div', _classNames[styles.hasAction] = hasAction, _classNames), className)
  }, other), children);
};

export { Card as default, ElevatedAction, FullWidthImage };